import React from 'react'
import { PageLayout } from 'components/PageLayout/PageLayout'

export const TheHeader = (props) => {
  return (
    <div className="bg-white">
      <PageLayout overflowHidden={false}>{props.renderTheNavbar()}</PageLayout>
    </div>
  )
}
